import Vue from "vue";
import Router from "vue-router";
import VueResource from "vue-resource";
import login from "@/components/login/index";
import main from "@/components/main/index";
import user from "@/components/user/index";
import role from "@/components/role/index";
import dashboard from "@/components/dashboard/index";
import resource from "@/components/resource/index";
import template from "@/components/template/index";
import generator from "@/components/generator/index";
import dictionary from "@/components/dictionary/index";
import flashSale from '@/components/conentSaleCenter/flashSale'
import schedule from "@/components/schedule/index";
import notFound from "@/components/notFound/index";
import subjectType from "@/components/subject/subjectType";
import subjectManage from "@/components/subject/subjectManage";
import subjectCourse from "@/components/subject/subjectCourse";
import subject from "@/components/subject/index";
import deptMgt from "@/components/deptMgt/deptMgt";
import answerQuiz from "@/components/question/answerQuiz";
import quizRank from "@/components/question/quizRank";
import quizDetail from "@/components/question/quizDetail";
import schoolPage from "@/components/schoolPage/index";
import addQuestion from "@/components/question/addQuestion";
import addCpQuestion from "@/components/question/addCpQuestion";
import teacher from "@/components/teacher/index";
import questionType from "@/components/questionType/index";
import chapter from "@/components/chapter/index_tree"; //
import testQuestions from "@/components/chapter/testQuestions"; //
import questionBankByMinSheng from "@/components/questionBankByMinSheng/index"; //民生题库
import question from "@/components/question/index";
import student from "@/components/student/index";
import scoreRule from "@/components/scoreRule/index_tree";
import exam from "@/components/exam/index";
import videoCourse from "@/components/videoCourse/index";
import videoInfo from "@/components/videoInfo/index";
import examType from "@/components/examType/index";
import questionQuery from "@/components/questionQuery/index";
import queryDetial from "@/components/questionQuery/queryDetial";
import questionQueryNew from "@/components/questionQueryNew/index";

import queryDetialNew from "@/components/questionQueryNew/queryDetialNew";

import addGoods from "@/components/goodsInfo/addGoods";
import goodsInfo from "@/components/goods/index";
import goGoodsInfo from "@/components/goodsInfo/goGoodsInfo";
import editGoods from "@/components/goodsInfo/editGoods";
import goodsItem from "@/components/goodsInfo/goodsItem";
import goodsItems from "@/components/goods/goodsItem";
import goodsNumber from "@/components/goodsInfo/goodsNumber";
import orderInfo from "@/components/orderInfo/index";
import agentLevel from "@/components/agentLevel/index";
import agentUserInfo from "@/components/agentUserInfo/index";
import agentInfo from "@/components/agentInfo/index";
import agentInfoApply from "@/components/agentInfoApply/index";
import tencentVideoInfo from "@/components/tencentVideoInfo/index";
import accessory from "@/components/accessory/index";

import examView from "@/components/examView/index";
import chapterView from "@/components/chapterView/index";

import applyGuide from "@/components/applyGuide/index";
import videoSet from "@/components/videoSet/index";
import sendNews from "@/components/newsCenter/sendNews";
import newsList from "@/components/newsCenter/newsList";
import newsDetail from "@/components/newsCenter/newsDetail";

import distributionLevel from "@/components/distributionLevel/index";
import distributionStatistics from "@/components/distributionStatistics/index";
import amountRules from "@/components/amountRules/index";

import addGoodsTaocan from "@/components/goods/addGoodsTaocan";
import editGoodsTaocan from "@/components/goods/editGoodsTaocan";

import materialCenter from "@/components/materialCenter/index";
import checkMaterial from "@/components/videoCourse/checkMaterial";
import checkVideo from "@/components/videoCourse/checkVideo";
import addVideoInfo from "@/components/videoCourse/addVideo";
import editVideoInfo from "@/components/videoCourse/editVideo";
import log from "@/components/log/index";
import specialExercise from "@/components/specialExercise/index";
import specialExerciseView from "@/components/specialExerciseView/index";
import specialExerciseQuestion from "@/components/specialExerciseQuestion/index";
import dailyExercise from "@/components/dailyExercise/index";
import onlineSchoolTemplateManage from "@/components/onlineTemplate/onlineSchoolTemplateManage";
import onlineSchoolTemplate from "@/components/onlineTemplate/index";
import onlineSchool from "@/components/onlineSchool/index";
import pcSetting from "@/components/onlineSchool/pcSetting";
import versionManagement from "@/components/versionManagement/index";
import designPage from "@/components/designPage/index.vue";
import design from "@/components/designPage/design.vue";
import xiaoETongLiveInfo from "@/components/xiaoETongLiveInfo/index";//小鹅通直播
import Feedback from "@/components/Feedback/index.vue"
import Feedbackdetailed from "@/components/Feedback/Feedbackdetailed.vue"

import routerK from "./routerK";
Vue.use(Router);
Vue.use(VueResource);

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

const router = new Router({
  routes: [{
      path: "/",
      name: "login",
      component: login
    },
    {
      meta: {
        auth: false
      },
      path: "/main",
      name: "main",
      component: main,
      redirect: "/dashboard",
      children: [
        ...routerK, // 防止冲突，路由另起
        {
          path: "/dashboard",
          name: "dashboard",
          component: dashboard
        },
        {
          meta: {
            auth: false
          },
          path: "/user",
          name: "用户管理",
          component: user
        },
        {
          meta: {
            auth: false
          },
          path: "/applyGuide",
          name: "报考指南",
          component: applyGuide
        },
        {
          meta: {
            auth: false
          },
          path: "/videoSet",
          name: "直播设置",
          component: videoSet
        },
        {
          meta: {
            auth: false
          },
          path: "/sendNews",
          name: "消息发布",
          component: sendNews
        },
        {
          meta: {
            auth: false
          },
          path: "/newsList",
          name: "消息列表",
          component: newsList
        },
        {
          meta: {
            auth: false
          },
          path: "/newsDetail",
          name: "消息详情",
          component: newsDetail
        },
        {
          meta: {
            auth: true
          },
          path: "/accessory",
          name: "附件管理",
          component: accessory
        },
        {
          meta: {
            auth: false
          },
          path: "/role",
          name: "角色管理",
          component: role
        },
        {
          meta: {
            auth: true
          },
          path: "/schoolPage",
          name: "PC网校",
          component: schoolPage
        },
        {
          meta: {
            auth: false
          },
          path: "/resource",
          name: "资源管理",
          component: resource
        },
        {
          meta: {
            auth: false
          },
          path: "/goGoodsInfo",
          name: "查看",
          component: goGoodsInfo
        },
        {
          meta: {
            auth: false
          },
          path: "/template",
          name: "代码生成",
          component: template
        },
        {
          meta: {
            auth: false
          },
          path: "/generator",
          name: "代码生成v2",
          component: generator
        },
        {
          meta: {
            auth: false
          },
          path: "/dictionary",
          name: "参数字典",
          component: dictionary
        },
        {
          meta: {
            auth: false
          },
          path: "/versionManagement",
          name: "APP版本管理",
          component: versionManagement
        },
        {
          meta: {
            auth: false
          },
          path: "/schedule",
          name: "定时任务",
          component: schedule
        },
        {
          meta: {
            auth: true
          },
          path: "/student",
          name: "学生管理",
          component: student
        },
        {
          meta: {
            auth: true
          },
          path: "/teacher",
          name: "教师管理",
          component: teacher
        },
        {
          meta: {
            auth: false
          },
          path: "/questionType",
          name: "题型管理",
          component: questionType
        },
        {
          meta: {
            auth: true
          },
          path: "/question",
          name: "试题管理",
          component: question
        },
        {
          meta: {
            auth: false
          },
          path: "/examView",
          name: "试卷试题",
          component: examView
        },
        {
          meta: {
            auth: false
          },
          path: "/chapterView",
          name: "章节试题",
          component: chapterView
        },
        {
          meta: {
            auth: false
          },
          path: "/addQuestion",
          name: "添加试题",
          component: addQuestion
        },
        {
          meta: {
            auth: false
          },
          path: "/addCpQuestion",
          name: "添加大题",
          component: addCpQuestion
        },
        {
          meta: {
            auth: false
          },
          path: "/subjectManage",
          name: "科目管理",
          component: subjectManage
        },
        {
          meta: {
            auth: false
          },
          path: "/subjectCourse",
          name: "具体课程",
          component: subjectCourse
        },

        {
          meta: {
            auth: false
          },
          path: "/deptMgt",
          name: "部门管理",
          component: deptMgt
        },
        {
          meta: {
            auth: false
          },
          path: "/subjectType",
          name: "科目类型",
          component: subjectType
        },
        {
          meta: {
            auth: true
          },
          path: "/chapter",
          name: "章节管理",
          component: chapter
        },
        {
          meta: {
            auth: true
          },
          path: "/scoreRule",
          name: "评分规则",
          component: scoreRule
        },
        {
          meta: {
            auth: false
          },
          path: "/testQuestions",
          name: "题管理",
          component: testQuestions
        },
        {
          meta: {
            auth: true
          },
          path: "/exam",
          name: "试卷管理",
          component: exam
        },
        {
          meta: {
            auth: true
          },
          path: "/questionBankByMinSheng",
          name: "民生题库",
          component: questionBankByMinSheng
        },
        {
          meta: {
            auth: true
          },
          path: "/videoCourse",
          name: "视频课程",
          component: videoCourse
        },
        {
          meta: {
            auth: false
          },
          path: "/checkVideo",
          name: "查看内容",
          component: checkVideo
        },
        {
          meta: {
            auth: false
          },
          path: "/checkMaterial",
          name: "查看内容",
          component: checkMaterial
        },
        {
          meta: {
            auth: false
          },
          path: "/designPage",
          name: "总模板",
          component: designPage
        },
        {
          meta: {
            auth: false
          },
          path: "/flashSale",
          name: "营销中心",
          component: flashSale
        },
        {
          meta: {
            auth: false
          },
          path: "/addVideoInfo",
          name: "添加录播视频",
          component: addVideoInfo
        },
        {
          meta: {
            auth: false
          },
          path: "/editVideoInfo",
          name: "编辑录播视频",
          component: editVideoInfo
        },
        {
          meta: {
            auth: true
          },
          path: "/videoInfo",
          name: "具体视频",
          component: videoInfo
        },
        {
          meta: {
            auth: true
          },
          path: "/goodsInfo",
          name: "商品管理",
          component: goodsInfo
        },
        {
          meta: {
            auth: false
          },
          path: "/goodsItems",
          name: "内容管理",
          component: goodsItems
        },
        {
          meta: {
            auth: false
          },
          path: "/answerQuiz",
          name: "问题答疑",
          component: answerQuiz
        },
        {
          meta: {
            auth: false
          },
          path: "/quizRank",
          name: "答疑排行",
          component: quizRank
        },
        {
          meta: {
            auth: false
          },
          path: "/quizDetail",
          name: "问题详情",
          component: quizDetail
        },
        {
          meta: {
            auth: true
          },
          path: "/subject",
          name: "科目课程管理",
          component: subject
        },
        {
          meta: {
            auth: false
          },
          path: "/goodsInfo/addGoods",
          name: "添加商品",
          component: addGoods
        },
        {
          meta: {
            auth: false
          },
          path: "/addGoodsTaocan",
          name: "添加套餐商品",
          component: addGoodsTaocan
        },
        {
          meta: {
            auth: false
          },
          path: "/editGoodsTaocan",
          name: "修改套餐商品",
          component: editGoodsTaocan
        },
        {
          meta: {
            auth: false
          },
          path: "/goodsInfo/editGoods",
          name: "修改商品",
          component: editGoods
        },
        {
          meta: {
            auth: false
          },
          path: "/goodsInfo/goodsItem",
          name: "内容管理",
          component: goodsItem
        },
        {
          meta: {
            auth: false
          },
          path: "/goodsInfo/goodsNumber",
          name: "查看销量",
          component: goodsNumber
        },
        {
          meta: {
            auth: true
          },
          path: "/orderInfo",
          name: "订单管理",
          component: orderInfo
        },
        {
          meta: {
            auth: false
          },
          path: "/agentLevel",
          name: "代理等级",
          component: agentLevel
        },
        {
          meta: {
            auth: true
          },
          path: "/agentUserInfo",
          name: "代理人员",
          component: agentUserInfo
        },
        {
          meta: {
            auth: true
          },
          path: "/agentInfo",
          name: "机构管理",
          component: agentInfo
        },
        {
          meta: {
            auth: false
          },
          path: "/agentInfoApply",
          name: "机构申请管理",
          component: agentInfoApply
        },
        {
          meta: {
            auth: false
          },
          path: "/examType",
          name: "试卷类型",
          component: examType
        },
        {
          meta: {
            auth: true
          },
          path: "/tencentVideoInfo",
          name: "腾讯云视频",
          component: tencentVideoInfo
        },
        {
          meta: {
            auth: true
          },
          path: "/questionQuery",
          name: "试题答疑",
          component: questionQuery
        },
        {
          meta: {
            auth: true
          },
          path: "/questionQueryNew",
          name: "试题答疑",
          component: questionQueryNew
        },
        {
          meta: {
            auth: false
          },
          path: "/queryDetial",
          name: "答疑详情",
          component: queryDetial
        },
        {
          meta: {
            auth: false
          },
          path: "/queryDetialNew",
          name: "答疑详情新",
          component: queryDetialNew
        },
        {
          meta: {
            auth: false
          },
          path: "/distributionLevel",
          name: "分销等级",
          component: distributionLevel
        },
        {
          meta: {
            auth: false
          },
          path: "/distributionStatistics",
          name: "分销统计",
          component: distributionStatistics
        },
        {
          meta: {
            auth: false
          },
          path: "/amountRules",
          name: "充值规则",
          component: amountRules
        },
        {
          meta: {
            auth: false
          },
          path: "/materialCenter",
          name: "素材中心",
          component: materialCenter
        },
        {
          meta: {
            auth: false
          },
          path: "/xiaoETongLiveInfo",
          name: "小鹅通直播",
          component: xiaoETongLiveInfo
        },
        {
          meta: {
            auth: false
          },
          path: "/log",
          name: "操作日志",
          component: log
        },
        {
          meta: {
            auth: true
          },
          path: "/specialExercise",
          name: "专项练习",
          component: specialExercise
        },
        {
          meta: {
            auth: false
          },
          path: "/specialExerciseView",
          name: "专题试题",
          component: specialExerciseView
        },
        {
          meta: {
            auth: true
          },
          path: "/specialExerciseQuestion",
          name: "专项练习习题",
          component: specialExerciseQuestion
        },
        {
          meta: {
            auth: true
          },
          path: "/dailyExercise",
          name: "每日一练",
          component: dailyExercise
        },
        {
          meta: {
            auth: false
          },
          path: "/onlineSchoolTemplateManage",
          name: "模板管理",
          component: onlineSchoolTemplateManage
        },
        {
          meta: {
            auth: false
          },
          path: "/onlineSchool",
          name: "网校总模板",
          component: onlineSchool
        },
        {
          meta: {
            auth: false
          },
          path: "/Feedback",
          name: "问题反馈",
          component: Feedback
        },
        {
          meta: {
            auth: false
          },
          path: "/Feedbackdetailed",
          name: "问题详情查询",
          component: Feedbackdetailed
        },
      ]
    },
    {
      path: "/notFound",
      name: "notFound",
      component: notFound
    },
    {
      meta: {
        auth: false
      },
      path: "/onlineSchoolTemplate",
      name: "模板编辑",
      component: onlineSchoolTemplate
    },
    {
      path: "/pcSetting",
      name: "模板设置",
      component: pcSetting
    },
    {
      path: "*",
      redirect: "/notFound"
    },
    {
      meta: {
        auth: false
      },
      path: "/design",
      name: "编辑总模板",
      component: design
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(m => m.meta.auth)) {
    if (localStorage.user != null) {
      let menus = JSON.parse(localStorage.user).resources;
      let flag = 1;
      menus.forEach(item => {
        if (to.path == item.url) {
          flag = 0;
        }
        item.resources.forEach(items => {
          if (to.path == items.url) {
            flag = 0;
          }
        });
      });
      if (flag === 0) {
        next();
      } else {
        next({
          path: "/notFound"
        });
      }
    } else {
      next({
        path: "/",
        query: {
          redirect: to.fullPath
        }
      });
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js